/* ============================================================
   INVENI — FOOTER JS
   Applies to: snippets/inveni-footer.liquid
   ============================================================ */

// Smooth back to top scroll
const backToTop = document.querySelector('.back-to-top-link');
if (backToTop) {
  backToTop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

// Optional: Fade in footer on scroll
const footer = document.querySelector('.inveni-footer');
if (footer) {
  footer.style.opacity = 0;
  footer.style.transition = 'opacity 1s ease';

  const footerObserver = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        footer.style.opacity = 1;
      }
    },
    { threshold: 0.2 }
  );

  footerObserver.observe(footer);
}

// Optional: Mobile accordion behavior for footer columns
const footerHeadings = document.querySelectorAll('.footer-col h4');
if (window.innerWidth < 900) {
  footerHeadings.forEach((heading) => {
    heading.style.cursor = 'pointer';

    const ul = heading.nextElementSibling;

    if (ul) {
      ul.style.maxHeight = '0px';
      ul.style.overflow = 'hidden';
      ul.style.transition = 'max-height 0.3s ease';
    }

    heading.addEventListener('click', () => {
      if (ul.style.maxHeight === '0px') {
        ul.style.maxHeight = ul.scrollHeight + 'px';
      } else {
        ul.style.maxHeight = '0px';
      }
    });
  });
}
